import { call, put, takeEvery } from "redux-saga/effects"

// Crypto Redux States
import { 
  GET_USERS, 
  GET_USERS_INACTIVE,
  GET_USER_PROFILE, 
  ADD_NEW_USER, 
  DELETE_USER, 
  UPDATE_USER,
  GET_MANUFACTURERS,
  ADD_MANUFACTURER,
  UPDATE_MANUFACTURER,
  DELETE_MANUFACTURER
} from "./actionTypes"

import {
  getUsersSuccess,
  getUsersFail,
  getUsersInActiveSuccess,
  getUsersInActiveFail,
  getUserProfileSuccess,
  getUserProfileFail,
  addUserFail,
  addUserSuccess,
  updateUserSuccess,
  updateUserFail,
  deleteUserSuccess,
  deleteUserFail,
  getManufacturersSuccess,
  getManufacturersFail,
  addManufacturerSuccess,
  addManufacturerFail,
  updateManufacturerSuccess,
  updateManufacturerFail,
  deleteManufacturerSuccess,
  deleteManufacturerFail
} from "./actions"

//Include Both Helper File with needed methods
import { 
  getUsers, 
  getUsersInActive,
  getUserProfile, 
  addNewUser, 
  updateUser, 
  deleteUser,
  getManufacturers
} from "../../helpers/backend_helper"

function* fetchUsers() {
  try {
    const response = yield call(getUsers)
    yield put(getUsersSuccess(response.data))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* fetchUsersInActive() {
  try {
    const response = yield call(getUsersInActive)
    yield put(getUsersInActiveSuccess(response.data))
  } catch (error) {
    yield put(getUsersInActiveFail(error))
  }
}

function* fetchUserProfile() {
  try {
    const response = yield call(getUserProfile)
    yield put(getUserProfileSuccess(response))
  } catch (error) {
    yield put(getUserProfileFail(error))
  }
}

function* onUpdateUser({ payload: user }) {
  try {
    const response = yield call(updateUser, user)
    yield put(updateUserSuccess(response.data))
  } catch (error) {
    yield put(updateUserFail(error))
  }
}

function* onDeleteUser({ payload: user }) {
  try {
    const response = yield call(deleteUser, user)
    yield put(deleteUserSuccess(response.data))
  } catch (error) {
    yield put(deleteUserFail(error))
  }
}

function* onAddNewUser({ payload: user }) {

  try {
    const response = yield call(addNewUser, user)

    yield put(addUserSuccess(response))
  } catch (error) {

    yield put(addUserFail(error))
  }
}

// Manufacturers

function* fetchManufacturers() {
  try {
    const response = yield call(getManufacturers)
    yield put(getManufacturersSuccess(response.data))
  } catch (error) {
    yield put(getManufacturersFail(error))
  }
}

function* onAddManufacturer({ payload: manufacturer }) {
  try {
    const response = yield call(addNewUser, manufacturer)
    yield put(addManufacturerSuccess(response))
  } catch (error) {

    yield put(addManufacturerFail(error))
  }
}

function* onUpdateManufacturer({ payload: manufacturer }) {
  try {
    const response = yield call(updateUser, manufacturer)
    yield put(updateManufacturerSuccess(response.data))
  } catch (error) {
    yield put(updateManufacturerFail(error))
  }
}

function* onDeleteManufacturer({ payload: manufacturer }) {
  try {
    const response = yield call(deleteUser, manufacturer)
    yield put(deleteManufacturerSuccess(response.data))
  } catch (error) {
    yield put(deleteManufacturerFail(error))
  }
}

function* usersSaga() {
  yield takeEvery(GET_USERS, fetchUsers)
  yield takeEvery(GET_USER_PROFILE, fetchUserProfile)
  yield takeEvery(ADD_NEW_USER, onAddNewUser)
  yield takeEvery(UPDATE_USER, onUpdateUser)
  yield takeEvery(DELETE_USER, onDeleteUser)
  yield takeEvery(GET_MANUFACTURERS, fetchManufacturers)
  yield takeEvery(ADD_MANUFACTURER, onAddManufacturer)
  yield takeEvery(UPDATE_MANUFACTURER, onUpdateManufacturer)
  yield takeEvery(DELETE_MANUFACTURER, onDeleteManufacturer)
  yield takeEvery(GET_USERS_INACTIVE, fetchUsersInActive)
}

export default usersSaga;
